import { useState } from "react";
import { toast } from "sonner";
import { errMsg } from "./useAuthedHttp";

export const CreditPanel = ({ call, credit }) => {
  const [show, setShow] = useState(credit.show);
  const [name, setName] = useState(credit.name || "");
  const save = async () => {
    try { await call("put", "/translations/credit", { show, name }); toast.success(show ? "You'll appear on the thank-you page" : "You're hidden from the thank-you page"); }
    catch (e) { toast.error(errMsg(e, "Could not save")); }
  };
  return (
    <section className="rounded-2xl bg-white border border-[#1C242B]/10 p-6" data-testid="credit-panel">
      <h2 className="font-display font-bold text-lg">Thank-you page credit</h2>
      <p className="text-sm text-slate-500 mt-1">Choose whether your name appears on the public <a href="/thanks" className="underline">Our translators</a> page.</p>
      <label className="mt-4 flex items-center gap-2 text-sm">
        <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} data-testid="credit-show-checkbox" className="accent-[#3E6B5C] w-4 h-4" />
        List me on the thank-you page
      </label>
      <div className="mt-3 flex gap-3">
        <input value={name} maxLength={60} onChange={(e) => setName(e.target.value)} placeholder="Name to show (e.g. Ana S.)" data-testid="credit-name-input"
          className="flex-1 rounded-full border border-[#1C242B]/15 bg-[#FAF8F5] px-4 py-2.5 text-sm" />
        <button onClick={save} data-testid="credit-save-btn" className="rounded-full bg-[#1C242B] text-white px-5 py-2.5 text-sm font-semibold hover:bg-black transition-colors">Save</button>
      </div>
    </section>
  );
};
